module.exports = "pegasus/assets/three-column-image-text-preview.png";